import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',[_c(VBtn,{attrs:{"icon":""}},[_c(VIcon,{staticClass:"icon",attrs:{"color":"grey"}},[_vm._v(_vm._s(_vm.icon))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }